module.exports = __webpack_public_path__ + "img/invite-a-friend-schema-ee.18b72e6c.png";